import { CreditCard, X } from "lucide-react";
import React from "react";
import LoadSettlementsTable from "./LoadSettlementsTable";
import SettlementsTransactionsTable from "./SettlementsTransactionsTable";

const LoadSettlementsTransactions: React.FC<{
  ref: string;
  setShowTransactionsModal: (arg0: boolean) => void;
}> = ({ ref, setShowTransactionsModal }) => {
  return (
    <section>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-start justify-center z-50 pt-8">
        <div className="bg-white rounded-lg p-6 w-full mx-4 max-h-[90vh] overflow-y-auto">
          <div className="border-b border-gray-200 pb-4 mb-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="flex items-center justify-center w-10 h-10 bg-blue-100 rounded-lg">
                  <CreditCard size={20} className="text-blue-600" />
                </div>
                <div>
                  <h2 className="text-xl font-semibold text-gray-900">
                    Settlement Transactions
                  </h2>
                  <p className="text-sm text-gray-500">Reference: {ref}</p>
                </div>
              </div>
              <button
                onClick={() => setShowTransactionsModal(false)}
                className="text-gray-400 hover:text-gray-600 transition-colors p-2 hover:bg-gray-100 rounded-lg"
              >
                <X size={24} />
              </button>
            </div>
          </div>

          <SettlementsTransactionsTable ref={ref} />
        </div>
      </div>
    </section>
  );
};

export default LoadSettlementsTransactions;
